// TODO: Change the name after OBS is retired
export const LOGIN_REFERRER_KEY = 'obs-deepLink';
//# sourceMappingURL=storage.js.map